import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlight';
}
export function Card({
  children,
  className = '',
  variant = 'default'
}: CardProps) {
  const baseStyles = 'rounded-xl overflow-hidden';
  const variants = {
    default: 'bg-white shadow-lg border border-gray-100',
    highlight: 'bg-emerald-50 border-2 border-emerald-500 shadow-xl'
  };
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-376">
      {children}
    </div>;
}